// Cart shared between the Shop and product pages (survives navigation/reload).
const KEY = 'shop_cart_v1';

export function readCart() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || '{}');
    return { items: c.items || {}, custom: c.custom || {} };
  } catch { return { items: {}, custom: {} }; }
}

export function writeCart(cart) {
  localStorage.setItem(KEY, JSON.stringify({ items: cart.items || {}, custom: cart.custom || {} }));
}
